<template>
  <div style="width:100%;height: 650px;">
    <div class="legend-list">
      <div class="legend-item legendfist" @click="optionChange('#0c85e3',1)">
        <div class="square" style="background-color: #0c85e3;"></div>
        <span class="legendtext">机具数量</span>
      </div>
      <div class="legend-item legendsecode" @click="optionChange('#da2688',2)">
        <div class="square" style="background-color: #da2688;"></div>
        <span class="legendtext">作业面积</span>
      </div>
      <div class="legend-item legendthid" @click="optionChange('#8729cf',3)">
        <div class="square" style="background-color: #8729cf;"></div>
        <span class="legendtext">已补贴资金</span>
      </div>
      <div class="legend-item legendfourth" @click="optionChange('#6db90a',4)">
        <div class="square" style="background-color: #6db90a;"></div>
        <span class="legendtext">剩余资金</span>
      </div>
    </div>
    <div id="barcirten"></div>
    <div v-if="jobSubsidyType==1" class="unit">单位：台/套</div>
    <div v-else-if="jobSubsidyType==2" class="unit">单位：亩</div>
    <div v-else class="unit">单位：万元</div>
  </div>
</template>

<script>
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
export default {
  name: 'JobChart',
  data () {
    return {
      color: '#0c85e3',
      jobSubsidyData:{},//作业补贴统计
      userLevel:'',//用户身份
      jobSubsidyType:1,//作业补贴统计类型
    }
  },
  mounted () {
    // this.polyline();
    this.workSubStatistics()
  },
  methods:{
    polyline () {
      const _this=this;
      this.DeviceChart = this.$echarts.init(document.getElementById('barcirten'))
      var seriesLabel = {
        normal: {
          show: true,
          textBorderColor: '#333',
          textBorderWidth: 2
        }
      }
      this.DeviceChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top:'4%',
            left: '5%',
            right: '4%',
            bottom: '-0%',
            containLabel: true
          },
          xAxis: {
            splitLine:{
              show:false
            },
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLine: {
              lineStyle: {
                color: '#192599'
              }
            },
            axisLabel: {
              interArrival: 0,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            }
          },
          yAxis: {
            splitLine:{
              show:false
            },
            type: 'category',
            nameLocation:'center',
            nameTextStyle:{
              color: '#60CAF1',
              fontSize:14,
            },
            nameStyle:{
              //文字颜色
              color:'#75C3FF',
            },
            data:this.jobSubsidyData.name,
            axisLine: {
              lineStyle: {
                color: '#192599'
              }
            },
            axisLabel: {
              interArrival: 0,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            },
            //去掉刻度线
            axisTick: {
              show: false
            },
          },
          series: [
            {
              name: this.jobSubsidyData.type,
              barWidth : 20,//柱图宽度
              type: 'bar',
              label: {//Y坐标数值显示；
                normal: {
                  position: 'right',
                  show: true
                },
                seriesLabel
              },
              data:this.jobSubsidyData.value,
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      fontSize: 16
                    }
                  },
                  //通过数组下标选择颜色
                  color: this.color
                }
              }
            },
          ]
        })
      // _this.DeviceChart.on('click',function(params){
      //   let code = params.data.code;
      //   let name = params.name;
      //   let userLevel = _this.userLevel;
      //   _this.$store.commit('Listparms', {code:code,name:name,userLevel:userLevel})
      //   _this.$router.push({name:'joblist',params: {code:code,name:name,userLevel:userLevel}})
      // })
      window.addEventListener("resize", () => { this.DeviceChart.resize();});
    },
    //改变参数
    optionChange (color,type) {
      this.color = color;
      this.jobSubsidyType=type;
      this.workSubStatistics(type);
      this.$emit('fnType',type);
    },
    /**
     * 作业补贴统计数据
     * @param {number} typeNum 统计类型
     */
    workSubStatistics(typeNum=1){
      let params={
        workSubsidyStatus:typeNum
      }
      Api.doPost(Http.workSubsidy.workSubStatistics, params, false, (res) => {
        let data=res.result;
        this.userLevel = data.userLevel;
        let type='',name=[],value=[];
        switch(parseInt(typeNum)){
          case 1:
            for(var i=0;i<data.agriMachNumList.length;i++){
              type='机具数量';
              name.push(data.agriMachNumList[i].name);
              var tempObj={
                value:data.agriMachNumList[i].total,
                code:data.agriMachNumList[i].code
              }
              value.push(tempObj);
            }
            break;
          case 2:
            for(var i=0;i<data.agriMachAreaList.length;i++){
              type='作业面积';
              name.push(data.agriMachAreaList[i].name);
              var tempObj={
                value:data.agriMachAreaList[i].totalArea,
                code:data.agriMachAreaList[i].code
              }
              value.push(tempObj);
            }
            break;
          case 3:
            for(var i=0;i<data.subsidedTotalList.length;i++){
              type='已补贴资金';
              name.push(data.subsidedTotalList[i].name);
              var tempObj={
                value:data.subsidedTotalList[i].susidedMoney,
                code:data.subsidedTotalList[i].code
              }
              value.push(tempObj);
            }
            break;
          case 4:
            type='剩余资金';
            for(var i=0;i<data.freeSubsidesList.length;i++){
              name.push(data.freeSubsidesList[i].name);
              var tempObj={
                value:data.freeSubsidesList[i].surplusMoney,
                code:data.freeSubsidesList[i].code
              }
              value.push(tempObj);
            }
            break;
          default:
            type='机具数量';
            for(var i=0;i<data.agriMachNumList.length;i++){
              name.push(data.agriMachNumList[i].name);
              var tempObj={
                value:data.agriMachNumList[i].total,
                code:data.agriMachNumList[i].code
              }
              value.push(tempObj);
            }
            break;
        }
        this.jobSubsidyData={
          type:type,
          name:name,
          value:value
        }
        this.polyline();
      })
    }
  }
}
</script>

<style scoped>
  #barcirten{
    width:100%;
    height:53vh;
  }
  .legend-list{
    display: flex;
    justify-content: center;
  }
  .legend-item{
    margin: 0 5px;
    cursor: pointer;
  }
   .legendfist{
    color: #0c85e3;
  }
  .legendsecode{
    color: #da2688;
  }
  .legendthid{
    color: #8729cf;
  }
  .legendfourth{
    color: #6db90a;
  }
  .legendtext{
    position: relative;
    bottom: 4px;
  }
  .square{
    display: inline-block;
    width: 18px;
    height: 18px;
  }
  .unit{
    margin-top: 5px;
    font-size: 16px;
    text-align: right;
	  color: #0c9be3;
  }
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/JobChart.vue